// The cross-school super-admin allow-list. This is the source of truth for the UI gate
// and MUST stay in sync with `isSuperAdmin()` in firestore.rules — the rules grant these
// accounts read/write across every collection, so the UI gate keys off the same values.
//
// Accounts can be matched by UID (stable, survives email changes) or by email (easier to
// reason about). Add new super-admins to BOTH lists here AND to firestore.rules.
export const SUPERADMIN_UIDS = ["IZENaQiXwcgjaWt4LV5O6zatp8J3"];
export const SUPERADMIN_EMAILS = ["mackml@gmail.com"];

export function isSuperAdmin({ uid, email } = {}) {
  if (uid && SUPERADMIN_UIDS.includes(uid)) return true;
  if (email && SUPERADMIN_EMAILS.includes(email.toLowerCase())) return true;
  return false;
}
